module.exports = __webpack_public_path__ + "img/fet.63cb915d.svg";